// import CryptoJS from "crypto-js";
import { unified } from "unified";
import markdown from "remark-parse";
import remark2rehype from "remark-rehype";
import html from "rehype-stringify";
import gfm from "remark-gfm";

export const toggleOpen = (isOpen, setIsOpen, index) => {
  const newIsOpen = [...isOpen];
  setIsOpen(newIsOpen);
};

export const generateRandomString = (number) => {
  const char = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let result = "";
  const charLength = char.length;
  const randomValues = new Uint32Array(number);
  crypto.getRandomValues(randomValues);

  for (let i = 0; i < number; i++) {
    result += char.charAt(randomValues[i] % charLength);
  }
  return result;
};

export const checkNumberType = (value) => {
  const isNumeric = /^\d+$/.test(value);
  if (!isNumeric) {
    return false;
  } else {
    return true;
  }
};

export const convertKeysToKorean = (obj) => {
  const koreanMapping = new Map([
    ["address", "주소"],
    ["area", "지역"],
    ["close", "휴관일"],
    ["contact", "연락처"],
    ["contact_name", "담당자"],
    ["description", "체험 내용"],
    ["duration", "소요 시간"],
    ["facilities", "시설"],
    // ['id', 'ID'],
    ["name", "체험명"],
    ["open", "영업 시간"],
    ["price", "가격"],
    ["programs", "프로그램"],
    ["subject", "과목"],
    ["target", "체험학습대상"],
    ["url", "홈페이지"],
  ]);

  const convertedObj = {};
  for (const [key, value] of Object.entries(obj)) {
    const koreanKey = koreanMapping.get(key) || key;
    convertedObj[koreanKey] = value;
  }

  return convertedObj;
};

export const checkGroupId = (e) => {
  const localData = window.localStorage.getItem("url");
  let value = null;
  if (localData) {
    const jsonData = JSON.parse(localData);
    value = jsonData;
  }
  return value;
};

export const convertTxtToKorean = (key) => {
  const koreanMapping = {
    link: "페이지 주소",
    title: "검색어",
    address: "주소",
    area: "지역",
    close: "휴관일",
    contact: "연락처",
    contact_name: "담당자",
    description: "상세 내용",
    duration: "소요 시간",
    facilities: "시설",
    id: "ID",
    name: "체험명",
    open: "영업 시간",
    price: "가격",
    programs: "프로그램",
    subject: "과목",
    target: "체험학습대상",
    url: "홈페이지",
    doc_name: "서식명",
    download: "서식",
    group: "그룹1",
    main_ref: "출처",
    subgroup: "그룹2",
  };

  let keyWord = koreanMapping[key];
  return keyWord;
};

export const convertToHtml = (string) => {
  const html_text = unified()
    .use(markdown)
    .use(gfm)
    .use(remark2rehype)
    .use(html)
    .processSync(string);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: html_text.value }}
      key={string.length}
    />
  );
};

export const checkIfToday = (date) => {
  const today = new Date();
  return date.toDateString() === today.toDateString();
};

export const resetZoom = () => {
  document.body.style.transform = "scale(1)";
  document.body.style.transformOrigin = "0 0";
  document.body.style.width = "100%";
};
export const checkIfWithinLast7Days = (date) => {
  const today = new Date();
  const sevenDaysAgo = new Date(today.setDate(today.getDate() - 7));
  return date > sevenDaysAgo;
};

export const backIncstance = async (method, url, data) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const socra_url = process.env.REACT_APP_SOCRATES_CATEGORY;
  const tutor_url = process.env.REACT_APP_TUTOR_CATEGORY;
  const greeting_url = process.env.REACT_APP_GREETING_MSG;
  const prompt_url = process.env.REACT_APP_PROMPT;

  try {
    // 헤더의 Content-Type을 설정합니다.
    const headers = {
      accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    // 요청 방식에 따라 Content-Type을 조정합니다.
    if (method === "POST" || method === "PATCH" || method === "PUT") {
      headers["Content-Type"] = "application/json";
    } else if (method === "GET" || method === "DELETE") {
      // GET 요청의 경우에는 데이터를 쿼리 문자열로 변환합니다.
      // const queryParams = new URLSearchParams(data).toString();
      if (data) {
        url += `${data}`;
      }
    }
    const includeToken =
      url.includes(socra_url) ||
      url.includes(tutor_url) ||
      url.includes(prompt_url) ||
      url.includes(greeting_url)
        ? false
        : true;
    // 요청 구성을 설정합니다.
    const config = {
      method: method,
      headers: headers,
      body:
        method === "POST" || method === "PATCH" || method === "PUT"
          ? JSON.stringify(data)
          : undefined,
      credentials: includeToken ? "include" : "omit", //2024.06.26 추가
    };
    const fullUrl = baseUrl + url;
    const response = await fetch(fullUrl, config);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ message: "응답 본문을 파싱할 수 없습니다." }));
      // 503 에러는 response.status로 확인 가능
      if (response.status === 503) {
        throw new Error(
          `서비스를 이용할 수 없습니다 (503): ${
            errorData.message || "서버 문제"
          }`,
        );
      }
      // throw new Error(`HTTP 에러: ${response.status} ${response.statusText} - ${errorData.message || '알 수 없는 오류'}`);
      return response;
    }
    return response;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const fileUpload = async (method, url, data) => {
  const boundary = "-----------------------------314159265358979323846";

  const headers = {
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    // 'Content-Type': `multipart/form-data boundary=${boundary}`,
    // 'Content-Type': `multipart/form-data`,
  };

  // 요청 구성을 설정합니다.
  const config = {
    method: method,
    headers: headers,
    body: data,
  };

  // fetch를 사용하여 요청을 보냅니다.
  const response = await fetch(url, config);

  // 응답을 반환합니다.
  return response;
};

export const imgUpload = async (method, url, data, token) => {
  const boundary = "-----------------------------314159265358979323846";

  const headers = {
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    // 'Content-Type': `multipart/form-data boundary=${boundary}`,
    // 'Content-Type': `multipart/form-data`,
  };

  // 요청 구성을 설정합니다.
  const config = {
    method: method,
    headers: headers,
    body: data,
    credentials: "include", //2024.06.26 추가
  };

  // fetch를 사용하여 요청을 보냅니다.
  const fullUrl = process.env.REACT_APP_BASE_URL + url;
  const response = await fetch(fullUrl, config);

  // 응답을 반환합니다.
  return response;
};

export const isNumber = (data) => {
  const number = Number(data);
  const isNan = isNaN(number);
  return !isNan;
};
// 숫자를 원화단위로 출력
export const formatToKoreanWon = (amount) => {
  const formattedAmount = new Intl.NumberFormat("ko-KR", {
    style: "currency",
    currency: "KRW",
  }).format(amount);
  const numericAmount = formattedAmount.replace(/[₩\s]/g, "");
  return numericAmount;
};

export const copyToClipboard = (item) => {
  alert("클립보드에 내용이 복사되었습니다.");
};

export const countVisitPerDay = (item) => {
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const visit = JSON.parse(sessionStorage.getItem("visit"));

  if (now > midnight) {
    sessionStorage.removeItem("visit");
    sessionStorage.setItem("visit", JSON.stringify(item));
  } else {
    sessionStorage.setItem("visit", JSON.stringify(item));
  }
};

export const sendVisitorCount = (url) => {
  let tday = new Date();
  let now = tday.getHours() + tday.getTime();
  let item = {
    value: now,
  };
  countVisitPerDay(item);
  backIncstance(url, undefined)
    .then((res) => {
      // console.log(res)
    })
    .catch((err) => {
      // console.log(err)
    });

  // 0시 기준으로 session에 저장하여
  // const value = sessionStorage.getItem('visit');

  // if (!value) {
  //   let tday = new Date();
  //   let now = tday.getHours() + tday.getTime();
  //   let item = {
  //     value: now
  //   }
  //   countVisitPerDay(item)
  //   backIncstance(VISIT_URL, undefined)
  //     .then((res) => {
  //     // console.log(res)
  //     })
  //     .catch((err) => {
  //     // console.log(err)
  //   })
  // }
};

export const deleteCookie = () => {
  // const main_url = process.env.REACT_APP_REFERER_URL;
  const main_url = "192.168.0.210";

  const cookies = document.cookie.split(";");
  const domains = [".dongascience.com", "dongascience.com", main_url];
  const paths = ["/"];

  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    domains.forEach((domain) => {
      paths.forEach((path) => {
        document.cookie =
          name +
          "=; path=" +
          path +
          "; domain=" +
          domain +
          "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      });
    });
  });
};

export const formatDateString = (dateString) => {
  // Date 객체로 변환
  const date = new Date(dateString);

  // 각 부분 추출
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth()는 0부터 시작하므로 +1
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // 원하는 형식으로 변환
  // return `${year}년 ${month}월 ${day}일 ${hours}시 ${minutes < 10 ? '0' + minutes : minutes}분`;
  return `${year}년 ${month}월 ${day}일`;
};

// YYYY.MM.DD 형식으로 변환 (유효하지 않은 값이면 빈 문자열)
export const formatFullDateString = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${date.getFullYear()}.${month}.${day}`;
};

export const formatDateStringShort = (dateString) => {
  // Date 객체로 변환
  const date = new Date(dateString);

  // 각 부분 추출
  const year = String(date.getFullYear()).slice(-2); // 마지막 2자리만
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0 패딩
  const day = String(date.getDate()).padStart(2, "0"); // 0 패딩

  // YY.MM.DD 형식으로 변환
  return `${year}.${month}.${day}`;
};

// export const setCookie = (name, value, days) => {
//   let expires = "";
//   if (days) {
//     const date = new Date();
//     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// Login 로그인 유무 체크 함수 240627
export const getLoginInfo = () => {
  let cookies = document.cookie.split("; ");
  const loginInfo = {
    id: null,
    accessToken: null,
    refreshToken: null,
  };

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].split("=");
    if (cookie[0].includes("accessToken")) {
      loginInfo.accessToken = cookie[1];
    } else if (cookie[0].includes("refreshToken")) {
      loginInfo.refreshToken = cookie[1];
    } else if (cookie[0].includes("login")) {
      loginInfo.id = cookie[1];
    }
  }
  // login 쿠키는 있지만 accessToken이 없으면 세션 무효로 간주
  // if (loginInfo.id && !loginInfo.accessToken) {
  //   // deleteCookie();
  //   loginInfo.id = null;
  // }

  return loginInfo; // 로그인 정보 객체를 반환
};

export const checkPwValidation = (password) => {
  let num = password.search(/[0-9]/g);
  let eng = password.search(/[a-z]/gi);
  let space = password.search(/\s/);

  let error = "";
  if (password.length < 8 || password.length > 20) {
    error = "비밀번호는 8자리~20자리 이내로 입력해주세요.";
  } else if (space !== -1) {
    error = "비밀번호는 공백이 포함될 수 없습니다.";
  } else if (num < 0 || eng < 0) {
    error = "영문, 숫자를 혼합하여 입력해주세요.";
  }
  return error === "" ? "success" : error;
};
// export const encryptoData = (text) => {
//   const jsonData = JSON.stringify(text)
//   const data = CryptoJS.AES.encrypt(jsonData, process.env.REACT_APP_SECRET_KEY).toString();
//   return data;
// }

// export const decryptData = (text) => {
//   const bytes = CryptoJS.AES.decrypt(text, process.env.REACT_APP_SECRET_KEY);
//   const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
//   const decryptedData = JSON.parse(decryptedString);
//   return decryptedData;
// }

export const detectUserAgent = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let agent = "";

  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      userAgent,
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      userAgent.substr(0, 4),
    )
  ) {
    // 모바일용 CSS 파일 경로
    agent = "MO";
  } else {
    // PC용 CSS 파일 경로
    agent = "PC";
  }
  return agent;
};

export const mobileScreenSize = () => {
  let vh = window.innerHeight * 0.01;
  return vh;
};
